import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { AuthContext } from "../Auth/AuthDataProvider.jsx";
import Footer from "../../views/Footer/Footer.jsx"

import { 
  Collapse,
  Divider,
  Button,
  Menu,
  MenuItem,
  Box,
  List,
  ListItem,
  Select,
} from '@material-ui/core';

// import Icon from '@material-ui/core/Icon';
import logoTextWhite from '../../assets/img/logo_text_white.png';

import { ReactComponent as ArrowRightIcon } from '../../assets/img/left_menu/arrow-right.svg';
import { ReactComponent as ArrowDownIcon } from '../../assets/img/left_menu/arrow-down.svg';
import { ReactComponent as DashboardIcon } from '../../assets/img/left_menu/dashboard.svg';
import { ReactComponent as JobsIcon } from '../../assets/img/left_menu/jobs.svg';
import { ReactComponent as LiveTrackingIcon } from '../../assets/img/left_menu/live-tracking.svg';
import { ReactComponent as CustomersIcon } from '../../assets/img/left_menu/customers.svg';
import { ReactComponent as ReportIcon } from '../../assets/img/left_menu/report.svg';
import { ReactComponent as VendorIcon } from '../../assets/img/left_menu/vendor.svg';
import { ReactComponent as ResourcesIcon } from '../../assets/img/left_menu/resources.svg';

import defaultImg from '../../assets/img/default_image.jpg';
import WMSIcon from '../../assets/img/services-icon1.png';
import LDSIcon from '../../assets/img/services-icon2.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faChartColumn, faFileLines, faGear, faLocationDot, faMessage, faTruck, faUsers } from '@fortawesome/free-solid-svg-icons'
import {RoleAccessService} from '../../data/role-access'; 
import apiUtil from '../../api/apiUtil.jsx';
const CustomMenuItem = (props) => {
  let {text, icon, url, active, items, onDrawerToggle} = props;
  let [open, setOpen] = React.useState(active);

  return <React.Fragment>
    <ListItem
      // onClick = {() => onDrawerToggle? onDrawerToggle(): ""}
      className={'custom-item ' + ((typeof active === "function") ? active() : (active ? "active" : ""))}
    >
      <Link to={(items && items.length > 0) ? "" : url}
        onClick={(e) => {
          // e.stopPropagation();

          if(items && items.length > 0){
            e.preventDefault();
            setOpen(!open);
            
            if(onDrawerToggle){
              onDrawerToggle()
            }
          }
        }}
        className="d-flex flex-column"
      >
        {icon ? <div className="icon-style">{icon}</div> : <span className={'no-icon'}></span>}
        <span className="nav-text">{text}</span>
        {(items && items.length > 0) && (open ? <ArrowDownIcon className={'custom-expand-down'} /> : <ArrowRightIcon className={'custom-expand-right'} />)}
      </Link>
    </ListItem>
    {(items && items.length > 0) && <Collapse in={open} timeout="auto" unmountOnExit>
      <List className={'sub-nav'} component="div" disablePadding>
        {items.map((item, i) => {
          return <React.Fragment key={i}>
            {item}
          </React.Fragment>;
        })}
      </List>
    </Collapse>}
  </React.Fragment>
}


class LeftMenu extends Component {
  static contextType = AuthContext;
  
  constructor(props){
    super(props); 
    this.state = {
      profileMenu: null,
    };
  }
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.profileMenu !== this.state.profileMenu) {
        this.setState({
            profileMenu: nextProps.profileMenu
        });
    }
  }
  
  validURL = (str) => {
    let pattern = new RegExp('^(https?:\\/\\/)?'+
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+
      '((\\d{1,3}\\.){3}\\d{1,3}))'+
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+
      '(\\?[;&a-z\\d%_.~+=-]*)?'+
      '(\\#[-a-z\\d_]*)?$','i');
    return !!pattern.test(str);
  }
  
  getUserLogo = () => {
    const { user } = this.context;
    return apiUtil.getUserLogo(user, defaultImg);
  }
  getUserName = () => {
    const { user } = this.context;
    return apiUtil.getUserName(user, defaultImg);
  }
  getUserEmail = () => {
    let userInfo = this.getUserinfo();

    return (userInfo && userInfo.email) ? userInfo.email : '';
  }



  getUserinfo = () => {
    const { user } = this.context;
    let userInfo = apiUtil.getObject(user);
    return (userInfo && userInfo.owner_info) ? userInfo.owner_info : null;
  }

  getCompanyID = () => {
    let company = window.localStorage.getItem('company_id');
    return company ? window.btoa( company ) : ''; //decript  window.atob( company )
  }
  
  logout = ()  => {
    const { clearStorage } = this.context;

    this.setState({
      profileMenu: null,
    });

    clearStorage();

    // window.location.reload();
    window.location = "/";
  }
  
  handleServiceChange = (e) => {
    let url = e.target.value;
    if (!this.validURL(url)) return false;
    window.location.replace(url);
  } 

  // get the the item list of resource for new role
  getResourceItemListForNewRole = (currentRole) => {
    let grantedMenu = new RoleAccessService();

    // 'Transport operator', 'Logistic assistance', 'Vehicle'
    let item_list = [] ;
    if( ! grantedMenu.admin_roles.includes(currentRole)) {
      if (grantedMenu.getUniqueRolePermission().includes('transport_operator')) {
          item_list.push(<CustomMenuItem
            onDrawerToggle={this.props.onDrawerToggle} 
            text={'Driver'}
            url={'/resources/transport-operators'}
            active={(this.props.location.pathname === "/resources/transport-operators" ? true : false)}
          />,
          <CustomMenuItem
            onDrawerToggle={this.props.onDrawerToggle} 
            text={'Driver Assistant'}
            url={'/resources/logistic-assistance'}
            active={(this.props.location.pathname === "/resources/logistic-assistance" ? true : false)}
          /> );
      }
      if (grantedMenu.getUniqueRolePermission().includes('resources_vehicle')) {
        item_list.push( <CustomMenuItem
          onDrawerToggle={this.props.onDrawerToggle}   
          text={'Vehicle'}
          url={'/resources/vehicle'}
          active={(this.props.location.pathname === "/resources/vehicle" ? true : false)}
        /> );
      }
      return item_list;
    }
    return item_list = [
      <CustomMenuItem
        onDrawerToggle={this.props.onDrawerToggle} 
        text={'Driver'}
        url={'/resources/transport-operators'}
        active={(this.props.location.pathname === "/resources/transport-operators" ? true : false)}
      />,
      <CustomMenuItem
        onDrawerToggle={this.props.onDrawerToggle} 
        text={'Driver Assistant'}
        url={'/resources/logistic-assistance'}
        active={(this.props.location.pathname === "/resources/logistic-assistance" ? true : false)}
      />,
      <CustomMenuItem
        onDrawerToggle={this.props.onDrawerToggle}   
        text={'Vehicle'}
        url={'/resources/vehicle'}
        active={(this.props.location.pathname === "/resources/vehicle" ? true : false)}
      />,
    ]
  }

  render() {
    const { isCustomerRequired, currentRole, appPermission } = this.context;
    let grantedMenu = new RoleAccessService();
    
    let wms_link = ""
    if(window.location.hostname === 'localhost' || window.location.hostname.includes('staging')) {
      wms_link = "https://staging-wms.evfy.sg/"
    } else {
      wms_link = "https://wms.evfy.sg/"
    }
   
    return <Box>
      <div style={{minHeight:"87vh", marginTop:'76px', overflow:'hidden'}} className="d-flex flex-column justify-content-between">   <List component="nav" className="customer-nav-style">
      {grantedMenu.getUniqueRolePermission().includes('dashboard') && <CustomMenuItem
          onDrawerToggle={this.props.onDrawerToggle} 
          text={'Dashboard'}
          icon={<DashboardIcon />}
          url={'/dashboard'}
          active={(this.props.location.pathname.includes("/dashboard") || this.props.location.pathname == "job-schedule-lists" || this.props.location.pathname.includes("/recycle-bin") ? true : false)}
        />
        }
       {grantedMenu.getUniqueRolePermission().includes('jobs') && <CustomMenuItem
          onDrawerToggle={this.props.onDrawerToggle} 
          text={'Analytics'}
          icon={<FontAwesomeIcon icon={faChartColumn} />}
          url={'/analytics/overview'}
          active={(this.props.location.pathname.includes("/analytics") || this.props.location.pathname.includes("/job-schedule-list")? true : false)}
        />}
        {grantedMenu.getUniqueRolePermission().includes('live_tracking') && currentRole != 'Finance Admin' && 
        <CustomMenuItem
          onDrawerToggle={this.props.onDrawerToggle} 
          text={'Location'}
          icon={<FontAwesomeIcon icon={faLocationDot} />}
          url={'/live-tracking/reload'}
          active={(this.props.location.pathname === "/live-tracking" || this.props.location.pathname === "/zones" ? true : false)}
        />
        }

        {grantedMenu.getUniqueRolePermission().includes('customers') && <CustomMenuItem
          onDrawerToggle={this.props.onDrawerToggle} 
          text={'Clients'}
          icon={<FontAwesomeIcon icon={faUsers} />}
          url={'/customers'}
          active={(this.props.location.pathname.includes("/customers") ? true : false)}
        />}
        {grantedMenu.getUniqueRolePermission().includes('transport_operator') ?
        <CustomMenuItem
          onDrawerToggle={this.props.onDrawerToggle} 
          text={'Drivers'}
          icon={<FontAwesomeIcon icon={faTruck} />}
          url={'/resources/transport-operators'}
          active={(this.props.location.pathname.includes("/resources") ? true : false)}
        /> : 
        grantedMenu.getUniqueRolePermission().includes('vendor') ? 
        <CustomMenuItem
        onDrawerToggle={this.props.onDrawerToggle} 
        text={'Drivers'}
        icon={<FontAwesomeIcon icon={faTruck} />}
        url={'/resources/vendor'}
        active={(this.props.location.pathname.includes("/resources") ? true : false)}
      /> : ''}
         {grantedMenu.getUniqueRolePermission().includes('invoice') && <CustomMenuItem
          onDrawerToggle={this.props.onDrawerToggle} 
          text={'Invoices'}
          icon={<FontAwesomeIcon icon={faFileLines} />}
          url={'/invoice/clients'}
          active={(this.props.location.pathname.includes("/invoice") ? true : false)}
        />}

        {/* {(grantedMenu.isShouldShowMenu(currentRole, "vendor")) && <CustomMenuItem
          onDrawerToggle={this.props.onDrawerToggle} 
          text={'Vendor'}
          icon={<VendorIcon />}
          url={'/vendor'}
          active={(this.props.location.pathname === "/vendor" ? true : false)}
        />
        } */}
        {/* {(grantedMenu.isShouldShowMenu(currentRole, "Resources")) &&
        <CustomMenuItem
          // onDrawerToggle={this.props.onDrawerToggle} 
          text={'Resources'}
          icon={<ResourcesIcon />}
          active={() => {
            if(this.props.location.pathname === "/resources/transport-operator") {
              return true
            } else if(this.props.location.pathname === "/resources/logistic-assistance") {
              return true
            } else if(this.props.location.pathname === "/resources/vehicle") {
              return true
            } else {
              return false;
            }
          }}
          //items list of resource of new enhancement role
          items={this.getResourceItemListForNewRole(currentRole)}          
        />
        } */}

      </List>
      <Button 
          aria-label="profile-menu-customer" 
          aria-haspopup="true"
          className="profile-menu-btn"
          onClick={(event) => {
            if(this.state.profileMenu != null) {
              this.setState({
                profileMenu: null
              });
            } else {
              this.setState({
                profileMenu: event.currentTarget
              });
            }
          }}
      >
          <img className="profile-pic-logo" src={this.getUserLogo()} alt="User" width="25" height="25" />
      </Button>
      <Menu
          id="profile-menu-customer"
          anchorEl={this.state.profileMenu}
          keepMounted
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          open={Boolean(this.state.profileMenu)}
          onClose={() => {
            this.setState({
              profileMenu: null
            });
          }}
      >   
          <div className="user-info">
            <img src={this.getUserLogo()} alt="User" 
              className="profile-pic-logo"
              width="35" height="35"/>
            <div className="user-info-right" style={{paddingLeft: '40px', paddingRight: '40px'}}>
              <div className="user-info-name">{this.getUserName()}</div>
              <div className="user-info-email">{this.getUserEmail()}</div>
            </div>
            
          </div>
          <Divider className="user-info-divider"/>
          {(grantedMenu.isShouldShowMenu(currentRole, 'List Application Setting')) &&
             <>
              <div className="user-info-2">
                {/* <img src={this.getUserLogo()} alt="User" 
                  className="profile-pic-logo"
                  width="35" height="35"/> */}
                <div className="user-info-name">Organization ID</div>
                <div className="user-info-right">
                  <div className="user-info-email">{this.getCompanyID()}</div>
                </div>
              </div>
              <Divider className="user-info-divider" />
          </>}
          {(grantedMenu.isShouldShowMenu(currentRole, "user_profile")) &&
            <MenuItem 
                onClick={() => {
                  // window.open("http://auth.worknode.ai/my-profile")
                  this.props.history.push({
                    pathname: '/setting-profile',
                    state: {
                      pathname: this.props.location.pathname
                    }
                  });
                }}
            >
                User profile
            </MenuItem>
          }
          {(grantedMenu.isPermissionActionAllowed(currentRole, "List Application Setting") || currentRole == 'Finance Admin' || currentRole == "BD Admin" || currentRole == "Ops Admin") &&
            <MenuItem 
                onClick={() => {
                  this.props.history.push({
                    pathname: '/general-settings',
                    state: {
                      pathname: this.props.location.pathname
                    }
                  });
                }}
            >   
                General Settings
            </MenuItem>
          } 
          {(grantedMenu.isShouldShowMenu(currentRole, "addmin_panel")) &&
            <MenuItem
              onClick={() => {
                window.open("http://auth.evfy.sg")
              }}
            >   Admin panel
            </MenuItem>
          }
          {(grantedMenu.isShouldShowMenu(currentRole, "zones")) &&
            <MenuItem 
                onClick={() => {
                  this.props.history.push({
                    pathname: '/zones',
                    state: {
                      pathname: this.props.location.pathname
                    }
                  });
                }}
            >   
                Zones
            </MenuItem>
          }
          <Divider className="user-info-divider"/>
          <MenuItem 
              onClick={() => {
                this.logout();
              }}
          >
              Sign Out
          </MenuItem>
      </Menu>
      <List component="nav" className="customer-nav-style" style={{paddingTop: 0}}>
         <CustomMenuItem
          onDrawerToggle={this.props.onDrawerToggle} 
          text={'Help'}
          icon={<FontAwesomeIcon icon={faMessage} />}
          url={'/help-center'}
          active={(this.props.location.pathname === "/help-center"? true : false)}
        />
      </List>
      </div>
    </Box>
  }

  
}

export default withRouter(LeftMenu);